
class Interop
{
    componentReference: any;

    get browserControl(): any {
        if(window)
        {
            if((window as any).external)
            {
                return (window as any).external;
            }
        }
    }

    public SetReference(componentReference: any){
        this.componentReference = componentReference;
    }

    public async Login(username: string, password: string){
        if(this.componentReference){
            await this.componentReference.invokeMethodAsync("Login", username, password);
        }
    }

    public LoginRequired()
    {
        if(this.browserControl && this.browserControl.LoginRequired)
        {
            this.browserControl.LoginRequired();
        }
    }
}

const interop = new Interop();
export { interop };
